import { Box } from '@mui/material'

import { DetailTab, type DetailTabToggleProps } from './DetailTabToggle.types'

const DetailTabToggle = ({ selectedTab, onTabChange }: DetailTabToggleProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        position: 'relative',
        borderRadius: '12px',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          border: '2px solid #F5F5F7',
          borderRadius: '12px',
          pointerEvents: 'none',
          zIndex: 0,
        },
      }}
    >
      <Box
        onClick={() => onTabChange(DetailTab.Overview)}
        sx={{
          flex: 1,
          padding: '12px 16px',
          textAlign: 'center',
          fontWeight: 500,
          fontSize: '14px',
          lineHeight: '20px',
          letterSpacing: '0.1px',
          backgroundColor: selectedTab === DetailTab.Overview ? '#181D29' : 'transparent',
          color: selectedTab === DetailTab.Overview ? '#ffffff' : undefined,
          borderRadius: '12px',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          position: 'relative',
          zIndex: 1,
        }}
      >
        Übersicht
      </Box>
      <Box
        onClick={() => onTabChange(DetailTab.Amortization)}
        sx={{
          flex: 1,
          padding: '12px 16px',
          textAlign: 'center',
          fontWeight: 500,
          fontSize: '14px',
          lineHeight: '20px',
          letterSpacing: '0.1px',
          backgroundColor: selectedTab === DetailTab.Amortization ? '#181D29' : 'transparent',
          color: selectedTab === DetailTab.Amortization ? '#ffffff' : undefined,
          borderRadius: '12px',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          position: 'relative',
          zIndex: 1,
        }}
      >
        Amortisation
      </Box>
    </Box>
  )
}

export default DetailTabToggle
